export const jurisprudenceTypes = [
  { id: "Por reiteración", name: "Por reiteración" },
  { id: "Por contradicción", name: "Por contradicción" },
  { id: "Por precedente", name: "Por precedente" },
];

export const epocas = [
  { id: "1ra", name: "1ra" },
  { id: "2ra", name: "2ra" },
  { id: "3ra", name: "3ra" },
];
